import { APP_PREFIX } from '@/shared/constants/app-prefix.constant';
import { USER_DOMAIN } from '@/shared/constants/user-domain.constant';
import { DomainOption } from '@/shared/lib/interfaces/domain-option.interface';

export const DOMAIN_OPTIONS: DomainOption[] = [
	{ domain: USER_DOMAIN.YACHTING, path: APP_PREFIX[USER_DOMAIN.YACHTING] },
	{ domain: USER_DOMAIN.INDUSTRIAL, path: APP_PREFIX[USER_DOMAIN.INDUSTRIAL] },
	{ domain: USER_DOMAIN.RESIDENTIAL },
];
